import script from "./RfidRogueListLogsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RfidRogueListLogsPage.vue?vue&type=script&setup=true&lang=js"

import "./RfidRogueListLogsPage.vue?vue&type=style&index=0&id=1830c22a&lang=css"

const __exports__ = script;

export default __exports__